import request from '@/api/request'

/**
 * 分页查询课程列表
 *
 * @param {*} data
 * @return {*}
 */

export const getPageList = data => {
  return request({
    url: 'product/adm/course/getListPage',
    method: 'post',
    type: 'json',
    data,
  })
}

/**
 * 添加课程
 *
 * @param {*} data
 * @return {*}
 */

export const addCourse = data => {
  return request({
    url: 'product/adm/course/addCourse',
    method: 'post',
    type: 'json',
    data,
  })
}

/**
 * 编辑课程
 *
 * @param {*} data
 * @return {*}
 */

export const updateCourse = data => {
  return request({
    url: 'product/adm/course/updateCourse',
    method: 'post',
    type: 'json',
    data,
  })
}

/**
 * 分页根据课程获取课时
 *
 * @param {*} data
 * @return {*}
 */

export const getHourByCourseId = data => {
  return request({
    url: 'product/adm/course/listCourseLseperiodByCourseId',
    method: 'post',
    type: 'json',
    data,
  })
}

/**
 * 分页根据课程获取课时
 *
 * @param {*} data
 * @return {*}
 */

export const updateCourseLesperiod = data => {
  return request({
    url: 'product/adm/courseLesperiod/updateCourseLesperiod',
    method: 'post',
    type: 'json',
    data,
  })
}

/**
 * 课程添加课时
 *
 * @param {*} data
 * @return {*}
 */

export const bindCourseLesperiod = data => {
  return request({
    url: 'product/adm/course/bindCourseLesperiod',
    method: 'post',
    type: 'json',
    data,
  })
}

/**
 * 课程删除课时
 *
 * @param {*} data
 * @return {*}
 */

export const delCourseLesperiod = data => {
  return request({
    url: 'product/adm/courseLesperiod/delCourseLesperiod',
    method: 'post',
    type: 'json',
    data,
  })
}

/**
 * 分页查询课程章节IDs
 *
 * @param {*} data
 * @return {*}
 */

export const getChapterIdList = data => {
  return request({
    url: 'product/adm/courseChapter/listCourseChapterByCourseId',
    method: 'post',
    type: 'json',
    data,
  })
}

/**
 * 分页查询课程章节列表
 *
 * @param {*} data
 * @return {*}
 */

export const getChapterPageList = data => {
  return request({
    url: 'product/adm/courseChapter/getListPage',
    method: 'post',
    type: 'json',
    data,
  })
}

/**
 * 添加课程章节
 *
 * @param {*} data
 * @return {*}
 */

export const addCourseChapter = data => {
  return request({
    url: 'product/adm/courseChapter/addCourseChapter',
    method: 'post',
    type: 'json',
    data,
  })
}

/**
 * 更新课程章节
 *
 * @param {*} data
 * @return {*}
 */

export const updateCourseChapter = data => {
  return request({
    url: 'product/adm/courseChapter/updateCourseChapter',
    method: 'post',
    type: 'json',
    data,
  })
}

/**
 * 删除课程章节
 *
 * @param {*} data
 * @return {*}
 */

export const delCourseChapter = data => {
  return request({
    url: 'product/adm/courseChapter/delCourseChapter',
    method: 'post',
    type: 'json',
    data,
  })
}
/**
 * 修改课程下课时排序
 *
 * @param {*} data
 * @return {*}
 */

export const updateCourseSort = data => {
  return request({
    url: 'product/adm/skuCourse/update',
    method: 'post',
    type: 'json',
    data,
  })
}
